import _ from 'lodash';
import { ApT, AMOUNT_FIELD as AP_AMOUNT, NAME_FIELD } from '../types';
import { ApOperationsT, AMOUNT_FIELD as OP_AMOUNT } from './types';

const UNAFFECTED_BUDGET = 'Montant non affecté';
export const getDisabled = (operation: ApOperationsT) =>
    operation[NAME_FIELD] === UNAFFECTED_BUDGET;

export const addUnaffectedBudget = (
    operations: Partial<ApOperationsT>[],
    ap: ApT,
) => {
    const result = _.cloneDeep(operations);
    const missingBudget = ap[AP_AMOUNT] - _.sumBy(operations, OP_AMOUNT);
    if (missingBudget > 0)
        result.push({
            label: UNAFFECTED_BUDGET,
            secondaryBudgetAxisElementAmount: missingBudget,
        });
    return result;
};
